import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { ConsultantsService } from 'src/app/services/consultants.service';
import { ConsultantsByProviderOrg } from 'src/app/models/consultant/consultant-by-provider-org.model';

@Component({
  selector: 'app-org-consultants',
  templateUrl: './org-consultants.component.html',
  styleUrls: ['./org-consultants.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class OrgConsultantsComponent implements OnInit, OnDestroy {
  @Input() organizationId: string | number;

  isLoading = false;
  consultantGroups: ConsultantsByProviderOrg[] = [];
  expandedGroups = new Set<number>();

  private subscriptions: Subscription[] = [];

  constructor(private consultantsService: ConsultantsService) {}

  ngOnInit(): void {
    this.loadConsultants();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadConsultants(): void {
    this.isLoading = true;
    const sub = this.consultantsService
      .getByProviderOrganizationId(Number(this.organizationId))
      .subscribe(response => {
        this.isLoading = false;
        if (!response.isError) {
          this.consultantGroups = response.data ?? [];
        }
      });
    this.subscriptions.push(sub);
  }

  toggleGroup(orgId: number): void {
    if (this.expandedGroups.has(orgId)) {
      this.expandedGroups.delete(orgId);
    } else {
      this.expandedGroups.add(orgId);
    }
  }

  isExpanded(orgId: number): boolean {
    return this.expandedGroups.has(orgId);
  }
}
